import { useQuery } from '@tanstack/react-query';

import { SITE_CONTEXT_CACHE_KEY } from './iwQueryClient';

export function useStateKey() {
    const { data } = useQuery({
        queryKey: [SITE_CONTEXT_CACHE_KEY]
    });

    // @ts-expect-error
    return data.data.state_key as string;
}
